import React from 'react';
import { SparklesIcon, PlayIcon, ZapIcon, XIcon, PencilOffIcon, VideoOffIcon } from 'lucide-react';
export function Hero() {
  const carouselImages = ['https://uploadthingy.s3.us-west-1.amazonaws.com/vDm6iRBC4WeG4NDS5K5RUV/IMG_1108.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/s2XRZQzkog1d9hUpseVWJE/IMG_1109.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ajDpp1ErSnUaimmMZPMKRS/IMG_1110.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/5UwSXUdmm6xzXUGKvuzM6Y/IMG_1111.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/weU5eC7cE1VvfiTMsSQgiU/IMG_1112.jpg'];
  return <section className="w-full px-4 py-8 md:py-24" data-id="element-145">
      <style data-id="element-146">
        {`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-400px * 5 - 1rem * 5));
            }
          }
          .animate-scroll {
            animation: scroll 40s linear infinite;
          }
        `}
      </style>
      <div className="max-w-5xl mx-auto text-center" data-id="element-147">
        <div className="inline-flex items-center gap-2 px-4 py-1 bg-purple-500/20 border border-purple-500/30 rounded-full mb-4 md:mb-6" data-id="element-148">
          <SparklesIcon className="w-3 h-3 text-purple-300" data-id="element-149" />
          <span className="text-purple-200 text-[10px] font-medium tracking-tight whitespace-nowrap" data-id="element-150">
            Sistema de creación de videos virales con inteligencia artificial
          </span>
        </div>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight px-2" data-id="element-151">
          De 0 a Video Viral en{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400" data-id="element-152">
            60 Minutos
          </span>{' '}
          Sin Mostrar Tu Cara
        </h1>
        <div className="mb-6 md:mb-8 px-2" data-id="element-153">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tpVJrgWpmm2WxewWjV4ZDo/VVM_5_BOXES.png" alt="Viral Video Machine IA - Sistema de creación de videos" className="w-full max-w-4xl mx-auto rounded-2xl shadow-2xl" data-id="element-154" />
          <p className="text-base md:text-lg text-gray-300 text-center mt-4 max-w-3xl mx-auto leading-relaxed" data-id="element-155">
            5 videos donde aprenderás paso a paso sin dejar nada afuera, más de
            40 minutos de un masterclass con{' '}
            <span className="text-purple-400 font-semibold" data-id="element-156">
              Gabriel Beltrán
            </span>
          </p>
        </div>
        <div className="mb-8 md:mb-10 px-2" data-id="element-157">
          <p className="text-sm md:text-base text-purple-300/80 font-light tracking-wide mb-4" data-id="element-158">
            videos that go viral all made by AI
          </p>
          <div className="overflow-hidden pb-4" data-id="element-159">
            <div className="flex gap-4 animate-scroll" data-id="element-160">
              {[...carouselImages, ...carouselImages].map((image, index) => <div key={index} className="flex-shrink-0" style={{
              aspectRatio: '9/16',
              height: '400px'
            }} data-id="element-161">
                  <img src={image} alt={`Viral video example ${index % carouselImages.length + 1}`} className="w-full h-full rounded-xl object-contain" data-id="element-162" />
                </div>)}
            </div>
          </div>
        </div>
        <div className="max-w-4xl mx-auto mb-6 md:mb-8 px-2" data-id="element-163">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-164">
            <div className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-green-500/20 to-emerald-500/20 border-2 border-green-500/40 rounded-xl backdrop-blur-sm" data-id="element-165">
              <XIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-166" />
              <span className="text-base md:text-lg font-bold text-green-300" data-id="element-167">
                Sin edición complicada
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 border-2 border-blue-500/40 rounded-xl backdrop-blur-sm" data-id="element-168">
              <PencilOffIcon className="w-5 h-5 text-blue-400 flex-shrink-0" data-id="element-169" />
              <span className="text-base md:text-lg font-bold text-blue-300" data-id="element-170">
                Sin escribir guiones
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-purple-500/20 to-pink-500/20 border-2 border-purple-500/40 rounded-xl backdrop-blur-sm" data-id="element-171">
              <VideoOffIcon className="w-5 h-5 text-purple-400 flex-shrink-0" data-id="element-172" />
              <span className="text-base md:text-lg font-bold text-purple-300" data-id="element-173">
                Sin aparecer frente a la cámara
              </span>
            </div>
          </div>
        </div>
        <p className="text-base md:text-xl text-gray-400 max-w-3xl mx-auto mb-6 md:mb-10 px-2" data-id="element-174">
          Usa este flujo de trabajo plug & play para planificar, escribir,
          diseñar, animar y publicar videos virales en menos de 60 minutos —
          incluso si nunca antes has creado uno.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-2" data-id="element-175">
          <a href="#pricing" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="w-full sm:w-auto group px-6 md:px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300" data-id="element-176">
            <div className="flex items-center justify-center gap-3" data-id="element-177">
              <PlayIcon className="w-5 h-5 flex-shrink-0" data-id="element-178" />
              <div className="text-left" data-id="element-179">
                <div className="text-base md:text-lg font-bold leading-tight" data-id="element-180">
                  Obtén Acceso Instantáneo
                </div>
                <div className="text-xl md:text-2xl font-extrabold leading-tight" data-id="element-181">
                  Solo $27
                </div>
              </div>
            </div>
          </a>
          <p className="text-sm text-gray-400 flex items-center gap-2" data-id="element-182">
            <ZapIcon className="w-4 h-4" data-id="element-183" />
            Acceso Inmediato • Garantía de 30 Días
          </p>
        </div>
        <div className="mt-8 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-3xl mx-auto" data-id="element-184">
          <div className="text-center" data-id="element-185">
            <div className="text-3xl font-bold text-purple-400 mb-2" data-id="element-186">
              1,500+
            </div>
            <div className="text-sm md:text-base text-gray-400" data-id="element-187">
              Creadores ya lo están usando
            </div>
          </div>
          <div className="text-center" data-id="element-188">
            <div className="text-3xl font-bold text-purple-400 mb-2" data-id="element-189">
              60 Min
            </div>
            <div className="text-sm md:text-base text-gray-400" data-id="element-190">
              De idea a video viral
            </div>
          </div>
          <div className="text-center" data-id="element-191">
            <div className="text-3xl font-bold text-purple-400 mb-2" data-id="element-192">$27</div>
            <div className="text-sm md:text-base text-gray-400" data-id="element-193">
              Pago único, sin suscripciones
            </div>
          </div>
        </div>
      </div>
    </section>;
}